import { memo } from 'react'

import { Debtor } from 'containers/PersonalForm/PersonalForm.interface'
import { Unit } from 'components/Input/Text'
import PathAmountInput from 'components/PathAmountInput'
import isRetired from 'utils/formDependencies/conditions/isRetired'
import { Box } from '@mui/material'

import { getHighestRetirementPension } from './utils'
import { observer } from 'mobx-react'
import { getCookie, COOKIE_KEY_FCID } from 'utils/cookie'
import { trackTeal } from 'utils/tracking'
import { useStores } from 'stores/utils/hooks/useStores'
import { AFFILIATE_ID_SMAVA } from 'utils/affiliate'

const RCEEditFieldDebtor = observer(
  ({ debtor = Debtor.PRIMARY, outerLabel = false, smallTextField = false }) => {
    const isPensionerOrDebtor = isRetired(debtor)
    const {
      traversal: {
        data,
        data: {
          debtors,
          debtors: {
            primary: { personId }
          },
          system: { subId, refId, configurationId, advertisementId }
        }
      }
    } = useStores()

    // the logic below should be done via formDependencies.tsx if the test is successful or at CAT-4118 cleanup
    const showPensionField = isPensionerOrDebtor(data)
    const pensions = showPensionField ? debtors[debtor].income.pensions : []
    const hasPensionOrRentner = getHighestRetirementPension(pensions || [])

    const onBlur = (value: number | undefined) => {
      if (value !== undefined) {
        trackTeal({
          transaction: {
            event: 'edit_page_rente_changed'
          },
          affiliateId: AFFILIATE_ID_SMAVA,
          subId,
          refId,
          configurationId,
          traversalPersonId: personId,
          context: {
            Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
            userAttributes: {
              advertisementId
            }
          }
        })
      }
    }

    return (
      <>
        <Box>
          <PathAmountInput
            path={`debtors.${debtor}.income.primary`}
            unit={Unit.EURO_MONTH}
            showTooltipOnFieldClick
            touchIgnored
            outerLabel={outerLabel}
            smallTextField={smallTextField}
          />
          {hasPensionOrRentner && (
            <PathAmountInput
              path={`debtors.${debtor}.income.pensions.${[hasPensionOrRentner.index]}.income`}
              unit={Unit.EURO_MONTH}
              showTooltipOnFieldClick
              touchIgnored
              label="Rente (netto)"
              defaultValue={hasPensionOrRentner.income}
              onBlur={onBlur}
              outerLabel={outerLabel}
              smallTextField={smallTextField}
            />
          )}
        </Box>
      </>
    )
  }
)

export default memo(RCEEditFieldDebtor)
